import {Autocomplete, Skeleton, TextField} from "@mui/material";
import {Control, Controller, UseFormSetValue, UseFormTrigger} from "react-hook-form";

function GeneralAutocomplete({control, formField, label, isFormDataLoading, options, setValue, trigger, xs = 12 , md = 12}: {
    control: Control<any>,
    formField: string,
    label: string,
    isFormDataLoading: boolean,
    options: any,
    setValue: UseFormSetValue<any>,
    trigger: UseFormTrigger<any>,
    xs?: number,
    md?: number
}) {
    return (
        isFormDataLoading ?
        <Skeleton variant="rounded" width={'100%'}>
            <TextField fullWidth={true} />
        </Skeleton> :
        <Controller
            name={formField}
            control={control}
            render={({ field, fieldState }) => (
                <Autocomplete
                    disablePortal
                    disableClearable
                    options={options}
                    onChange={(e,v)=>{
                        setValue(formField, v.id);
                        trigger(formField);
                    }}
                    onFocus={() => {trigger(formField)}}
                    value={options.find(option => option.id == field.value)||null}
                    renderInput={(params) => 
                        <TextField 
                            {...params} 
                            label={label} 
                            fullWidth
                            error={Boolean(fieldState.error)}
                            helperText={fieldState.error?.message}
                        />
                    }
                />
            )}
        />
);
}

export default GeneralAutocomplete;
